import { render } from "./ActivationItem.vue?vue&type=template&id=9b1e3b08&scoped=true"
import script from "./ActivationItem.vue?vue&type=script&lang=js"
export * from "./ActivationItem.vue?vue&type=script&lang=js"

import "./ActivationItem.vue?vue&type=style&index=0&id=9b1e3b08&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b1e3b08"]])

export default __exports__